import './donut_pie_chart_view.js.coffee'

class Monitoring.Views.Charts.GeoHierarchyChartView extends Monitoring.Views.Charts.DonutPieChartView

  initialize: ->
    @title = I18n.t('monitoring.dashboard.charts.h_location')
    @title_en = I18n.t('monitoring.dashboard.charts.h_location', {'locale': 'en'})
    super
    @url = '/monitoring/dashboard/charts/geo_hierarchy'

  afterAppend: ->
    if @data
      super
    else
      @ajaxCall(@url, @searchQuery.toJSON(), (response) =>
        @data = response
        super
      )
    return this

  getNewQuery: (event) ->
    locations = @_join_tags(event.point)
    query = @searchQuery.deepCopy()
    query.set('locations', locations)
    return query

  _benchmarkDataFromResponse: () ->
    @dataBenchmark.levels[0]
